var exports = {
  "kL": "x2b2fbebb--0f9cc9--container",
  "Sl": "x2b2fbebb--0f9cc9--image",
  "h_": "x2b2fbebb--0f9cc9--description",
  "XI": "x2b2fbebb--0f9cc9--action",
};

module.exports = exports;
